import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { CommonService } from '../../common-service';
import { TemplateSubgroupSelectResponse } from '../../responses/pharmacy/template-subgroup-select.response';

@Injectable({
  providedIn: 'root'
})
export class TemplateSubgroupSelectService extends CommonService {

  constructor(private router: Router, private httpClient: HttpClient, configService: AppConfigService, private endpointBuilder: EndpointBuilderService) {
    super(configService);
  }

  list(): Observable<TemplateSubgroupSelectResponse> {
    let uri = `TemplateSubgroupSelect?`;

    return this.httpClient.get<TemplateSubgroupSelectResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiPharmacy) + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }
}